import * as React from "react";

const auditConfig = (t) => ({
  defaultTab: "verification",
  tabs: [
    {
      title: t ? t("object_types.line") : "Linie",
      type: "line",
      moduleObjectHeader: t ? t("object_types.line") : "Linia",
      parentObjectHeader: t ? t("object_types.machine") : "Maszyna",
      parentObjectType: "enum",
      parentObjectEnumType: "enums/machineType",
      objectHeader: t ? t("object_types.format_part") : "Część formatowa",
      additionalFields: [
        // {
        //   label: "ID",
        //   field: "verificationId",
        //   width: 200
        // }
      ],
      // infoAction: {
      //   redirectTo: function(verification) {
      //     return `/#/verification/${verification.verificationId}`;
      //   }
      // }

    },
    {
      title: t ? t("common.machine_models") : "Modele maszyn",
      type: "machine-model",
      moduleObjectHeader: t ? t("object_types.machine_model") : "Model maszyny",
      objectHeader: t ? t("object_types.format_part") : "Część formatowa",
      additionalFields: [
        // {
        //   label: "ID",
        //   field: "verificationId",
        //   width: 200
        // }
      ],
      // infoAction: {
      //   redirectTo: function(verification) {
      //     return `/#/verification/${verification.verificationId}`;
      //   }
      // }

    },
    {
      title: t ? t("menu.formats") : "Formaty",
      type: "format",
      moduleObjectHeader: t ? t("object_types.format") : "Format",
      objectHeader: t ? t("object_types.part") : "Część",
      additionalFields: [
        // {
        //   label: "ID",
        //   field: "verificationId",
        //   width: 200
        // }
      ],
      // infoAction: {
      //   redirectTo: function(verification) {
      //     return `/#/verification/${verification.verificationId}`;
      //   }
      // }

    },
    {
      title: t ? t("menu.production") : "Produkcja",
      type: "production",
      moduleObjectHeader: t ? t("object_types.line") : "Linia",
      objectHeader: t ? t("object_types.production") : "Produkcja",
      hideObject: true,
      additionalFields: [
      ],
    },
    {
      title: t ? t("menu.storage_place") : "Szafy formatowe",
      type: "storage",
      moduleObjectHeader: t ? t("object_types.storage_place") : "Szafa formatowa",
      objectHeader: t ? t("object_types.storage_place") : "Szafa formatowa",
      hideObject: true,
      additionalFields: [
      ],
    },
    {
      title: t ? t("menu.alarms") : "Alarmy",
      type: "alarm",
      moduleObjectHeader: t ? t("object_types.alarm") : "Alarm",
      objectHeader: t ? t("object_types.alarm") : "Alarm",
      hideObject: true,
      additionalFields: [
      ],
    },
    {
      title: t ? t("object_types.font") : "Czcionki",
      type: "font",
      moduleObjectHeader: t ? t("object_types.machine") : "Maszyna",
      parentObjectHeader: t ? t("object_types.line") : "Linia",
      objectHeader: t ? t("object_types.font") : "Czcionki",
      hideObject: true,
      moduleObjectType: "enum",
      moduleObjectEnumType: "enums/machineType",
      additionalFields: [
      ],
    },
    {
      title: t ? t("menu.fast_acting_parts") : "Części szybkozużywające się",
      type: "fastActingPart",
      moduleObjectHeader: t ? t("object_types.part") : "Część",
      hideObject: true,
      additionalFields: [
      ],
    },
    {
      title: t ? t("common.dictionaries") : "Słowniki",
      type: "dictionary",
      moduleObjectHeader: t ? t("common.dictionary") : "Słownik",
      hideObject: true,
      additionalFields: [
      ],
    },
    // {
    //   title: "Weryfikację narzędzi",
    //   type: "tool",
    //   additionalFields: [
    //     {
    //       label: "ID weryfikacji",
    //       field: "verificationId",
    //       width: 200
    //     },
    //     {
    //       label: "Numer narzędzia",
    //       field: "toolNumber",
    //       width: 200
    //     },
    //     {
    //       label: "Typ narzędzia",
    //       field: "toolType",
    //       width: 200,
    //       type: "enum",
    //       enumType: "enums/toolType",
    //     }
    //
    //   ],
    //   infoAction: {
    //     redirectTo: function(tool) {
    //       return `/#/verification/${tool.verificationId}/?tool=${tool.toolId}`;
    //     }
    //   }
    //
    // }
  ]

});

export default auditConfig;